<ng-template vdrDialogTitle>
    {{ 'catalog.assign-facets-to-bulk-channels' | translate }}
</ng-template>

<div class="flex" style="height: auto; flex-wrap: wrap;">
    <!-- Only show the facets if selectedFacetIds contains values -->
    <div *ngIf="selectedFacetIds.length > 0" style="margin-bottom: 20px;">
        <div class="facets-select">
            <div class="flex">
                <div *ngFor="let facet of availableFacets">
                    <!-- Only render facets whose ids are included in selectedFacetIds -->
                    <span *ngIf="selectedFacetIds.includes(facet.id)">
                        <span class="badge badge-info">
                            {{ facet.name }} ({{ facet.code }})
                            <!-- Cross button to remove the facet -->
                            <button class="close-btn" (click)="removeFacet(facet.id)">×</button>
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template vdrDialogButtons>
    <button type="button" class="btn" (click)="cancel()">
        {{ 'common.cancel' | translate }}
    </button>
    <button type="submit" class="btn btn-primary" [disabled]="!selectedFacetIds?.length" (click)="assign()">
        {{ 'catalog.assign-facets-to-bulk-channels' | translate }}
    </button>
</ng-template>
